import Vue from 'vue'
import App from './App.vue'
import VueRouter from 'vue-router';
import BootstrapVue from 'bootstrap-vue/dist/bootstrap-vue.esm';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import { routes } from './router.js';
import { myMixin } from './helpers.js';
import VueScrollReveal from 'vue-scroll-reveal';
import VueResource from 'vue-resource';
import { BootstrapVueIcons } from 'bootstrap-vue'

Vue.use(BootstrapVueIcons)
Vue.use(VueResource);
Vue.mixin(myMixin);
Vue.use(VueScrollReveal);

Vue.use(VueScrollReveal, {
  class: 'v-scroll-reveal', // A CSS class applied to elements with the v-scroll-reveal directive; useful for animation overrides.
  duration: 800,
  scale: 1,
  distance: '10px',
  mobile: false
});

var VueScrollTo = require('vue-scrollto');

Vue.use(VueScrollTo, {
     container: "body",
     duration: 500,
     easing: "ease",
     offset: -85,
     force: true,
     cancelable: true,
     onStart: false,
     onDone: false,
     onCancel: false,
     x: false,
     y: true
 })

Vue.config.productionTip = false

Vue.use(BootstrapVue);

Vue.use(VueRouter);

const router = new VueRouter({
  routes,
  mode: 'history',
  base: '/'
});

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
